import React, { useState, useEffect, useMemo } from "react";
import ReactDOM from "react-dom";
import Dropdown from "react-bootstrap/Dropdown";
import styled, { css, withTheme } from "styled-components";

const StyledDropdown = styled(Dropdown)`
  .dropdown-toggle {
    background: ${(props) => props.theme?.whiteSmoke};
    box-shadow: 0px 3px 6px #0000001a;
    border-radius: 7px;
    border: 0;
    color: black;
    font-weight: 600;
    font-size: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    ${(props) =>
      props.size !== "small" &&
      css`
        min-width: 0px;
        padding: 8px 8px;
      `}

    &::after {
      ${(props) =>
        props.disabled &&
        css`
          display: none;
        `}
    }
  }

  &.show > .dropdown-toggle {
    background-color: ${(props) =>
      !props.$hideDropDownMenu || props.$active
        ? props.theme?.violetEggplant
        : props.theme?.whiteSmoke};
    color: ${(props) =>
      !props.$hideDropDownMenu || props.$active ? "white" : "black"};
  }

  .dropdown-toggle {
    ${(props) =>
      props.$active &&
      css`
        background-color: ${(props) => props.theme?.violetEggplant} !important;
        color: white;
      `}

    &:hover {
      background-color: ${(props) => props.theme?.whiteSmoke} !important;
      color: black !important;
    }
  }

  &.show > .btn-primary.dropdown-toggle:focus {
    box-shadow: 0px 3px 6px #0000001a;
  }

  .btn-primary:not(:disabled):not(.disabled):active,
  .btn-primary:not(:disabled):not(.disabled).active,
  .show > .btn-primary.dropdown-toggle {
    background-color: white;
    color: black;
  }
`;

const StyledDropdownToggle = styled(Dropdown.Toggle)`
  ${(props) =>
    props.$hidden &&
    css`
      opacity: 0;
      position: absolute;
      top: 7px;
    `}
`;

const StyledDropDownMenu = styled(Dropdown.Menu)`
  box-shadow: 0px 3px 6px #0000004d;
  border-radius: 7px;
  border: 0;
  color: black;
  font-weight: 600;
  font-size: 16px;
  min-width: ${(props) => `${props.width || 0}px`};
  max-height: ${(props) => (props.limitheight ? "500px" : "none")};
  overflow-y: ${(props) => (props.limitheight ? "scroll" : "visible")};
  .dropdown-item {
    color: black;
    font-weight: 600;
    font-size: 16px;
    padding: 5px 15px;
  }
`;

const DropDownMenu = (props) => {
  let { children, placeInElement = document.body, limitheight, width } = props;
  if (!placeInElement) {
    placeInElement = document.body;
  }

  const getLimitHeight = useMemo(() => {
    if (limitheight) {
      return typeof limitheight === "number" ? !!limitheight : +limitheight;
    }
    return limitheight;
  }, [limitheight]);

  return ReactDOM.createPortal(
    <StyledDropDownMenu limitheight={getLimitHeight} width={width}>
      {children}
    </StyledDropDownMenu>,
    placeInElement
  );
};

const CustomDropdownLabels = (props) => {
  const {
    placeholder,
    values,
    onChange,
    width,
    disabled,
    limitheight,
    defaultValue,
    tabIndexProp,
    reset,
    size,
    onClick,
    className,
    dropdownToggleRef,
    hiddenToggle,
    active,
  } = props;

  const [selected, setSelected] = useState(null);

  const onChangeCallback = (item) => {
    if (onChange) {
      onChange(item);
    }

    setSelected(item);
  };

  useEffect(() => {
    if (reset === 1) {
      setSelected(null);
    }
  }, [reset]);

  useEffect(() => {
    if (placeholder) {
      setSelected(null);
    }
  }, [placeholder]);

  useEffect(() => {
    if (!selected && values && defaultValue) {
      setSelected(defaultValue);
    }
  }, [selected, defaultValue, values]);

  return (
    <StyledDropdown
      className={className}
      width={width}
      disabled={disabled}
      onClick={onClick}
      $active={active}
      $hideDropDownMenu={!!onClick}
    >
      <StyledDropdownToggle
        tabIndex={tabIndexProp}
        id={props["id"] || "custom-dropdown"}
        data-testid={props["data-testid"] || "custom-dropdown"}
        ref={dropdownToggleRef}
        $hidden={hiddenToggle}
      >
        {size === "small"
          ? ""
          : selected?.label?.replace("    ", "") ??
            selected ??
            placeholder ??
            ""}
      </StyledDropdownToggle>

      {values && values.length > 0 && (
        <DropDownMenu limitheight={limitheight} width={width}>
          {values?.map((item, i) => (
            <Dropdown.Item
              key={`key_${item.value ?? item}_${i}`}
              data-testid={`item-${item.value ?? item}`}
              onClick={() => onChangeCallback(item)}
            >
              {item.label}
            </Dropdown.Item>
          ))}
        </DropDownMenu>
      )}
    </StyledDropdown>
  );
};

export default withTheme(CustomDropdownLabels);
